import { FC, ReactNode } from "react"
import { Icon, IconColor } from "@/components/shared/Icon"
import { TestId } from "@/constants/globals"

type FormSentProps = {
   title: string
   description: ReactNode
}

const FormSent: FC<FormSentProps> = ({ title, description }) => {
   return (
      <div className="clear-alert-modal-form-sent">
         <Icon
            name="shield"
            size="64"
            color={IconColor.HONOLULU_BLUE}
         />
         <div
            className="clear-alert-modal-form-sent__text"
            data-testid={TestId.CLEAR_ALERT_MODAL_FORM_SENT_TEXT}
         >
            <h4>{title}</h4>
            <div className="clear-alert-modal-form-sent__text-description">
               {description}
            </div>
         </div>
      </div>
   )
}

export default FormSent
